<template>
  <v-container fluid>
    <!-- <v-breadcrumbs :items="items">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs> -->
    <div id="app ">
      <v-row>
        <v-col cols="11">
          <Breadcrumb
            class="row justify-content-center mt-4"
            :crumbs="crumbs"
            @selected="selected"
          />
        </v-col>
        <v-col cols="1" v-if="showLoader">
          <LoaderProgress></LoaderProgress>
        </v-col>
      </v-row>
    </div>
    <v-row>
      <v-col>
        <!-- <filterHeaderComp /> -->
        <newFiltercomp :filter_data="param" />
      </v-col>
    </v-row>
    <v-data-table
      ref="theDataTable"
      :headers="headersData"
      :items="operatorsData"
      :search="search"
      :custom-sort="DateSort"
      :expanded.sync="expanded"
      :items-per-page="10"
      item-key="Timestamp"
      class="elevation-1"
      show-expand
      
      @pagination="pagination = $event"
    >
    <template v-slot:expanded-item="{ item }">   
       <v-spacer></v-spacer>
      <td :colspan="5">
       
        <v-simple-table>
          
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Product Name</th>
                      <th>Production Quantity</th>
                      <th>Wastage</th>
                      
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="source in item.product_details" :key="source.product_name">
                      <td>{{ source.product_name }}</td>
                      <td>{{ source.Production_Quantity ||0 }}</td>
                      <td>{{ source.Wastage || 0}}</td>
                      
                    </tr>
                  </tbody>
                </template>
            </v-simple-table>

        
      </td>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
          <!-- <v-dialog v-model="dialog" max-width="800px">
            
            <template v-slot:activator="{ on, attrs }">

              <v-btn
                fab
                small
                outlined
                color="#0C479D"
                style="margin: 0px 5px 0px -2px"
              >
                <vue-json-to-csv
                  :json-data="dataDownload"
                  :csv-title="'Production Data'"
                >
                  <v-icon>mdi-table</v-icon>
                </vue-json-to-csv>
              </v-btn>
            </template>
          </v-dialog> -->
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-width="50"
            offset-x
          >
          
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class=""
                outlined
                fab
                small
                color="#0C479D"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>icon-download</v-icon>
              </v-btn>
            </template>

            <v-card>
              <!-- <v-list> -->
              <!-- <v-list-item> -->
              <!-- <v-list-item-avatar>
              <img
                src="https://cdn.vuetifyjs.com/images/john.jpg"
                alt="John"
              >
            </v-list-item-avatar> -->

              <!-- <v-list-item-content> -->
              <!-- <v-list-item-title class="font-weight-bold text-blue text-uppercase">options</v-list-item-title> -->
              <!-- <v-list-item-subtitle>Founder of Vuetify</v-list-item-subtitle> -->
              <!-- </v-list-item-content> -->

              <!-- <v-list-item-action>
              <v-btn
                :class="fav ? 'red--text' : ''"
                icon
                @click="fav = !fav"
              >
                <v-icon>mdi-heart</v-icon>
              </v-btn>
            </v-list-item-action> -->
              <!-- </v-list-item> -->
              <!-- </v-list> -->

              <v-divider></v-divider>

              <v-list>
                <v-list-item>
                  <v-list-item-action>
                    <vue-json-to-csv
                      :json-data="dataDownload"
                      :csv-title="'Machine Production Report Data'"
                    >
                      <v-btn color="indigo" dark style="">
                        CSV
                      </v-btn>
                    </vue-json-to-csv>

                    <!-- <v-btn
          color="indigo"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Menu as Popover
        </v-btn> -->
                  </v-list-item-action>
                  <!-- <v-list-item-title>CSV Download</v-list-item-title> -->
                </v-list-item>

                <v-list-item>
                  <v-list-item-action>
                    <v-btn @click="createPDF" color="indigo" dark>PDF </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
        </v-toolbar>
      </template>

      <!-- <template v-slot:no-data>
        <v-btn color="primary" @click="initialize"> Reset </v-btn>
      </template> -->
    </v-data-table>
  </v-container>
</template>
<script>
// import filterHeaderComp from "../components/filterHeaderComp.vue";
import Breadcrumb from "../components/breadcrumbs.vue";
import LoaderProgress from "../components/progressLoader";
import newFiltercomp from "../components/newFiltercomp.vue";
import axios from "axios";
import VueJsonToCsv from "vue-json-to-csv";
// import constants from "../constants";
import router from "../router";
import jsPDF from "jspdf";
import "jspdf-autotable";
// const logo = require("../assets/trinitiimage.png");
export default {
  components: {
    VueJsonToCsv,
    newFiltercomp,
    //  filterHeaderComp
    Breadcrumb,
    LoaderProgress,
  },

  data() {
    return {
      crumbs: ["Home", "Report Menu", "Machine Production Report"],

      items: [
        {
          text: "Home",
          disabled: false,
          href: "/",
        },
        {
          text: "Report Menu",
          disabled: true,
          href: "/",
        },
        {
          text: "Machine Production Report",
          disabled: true,
        },
      ],
      showWarning: false,
      showLoader: false,
      param : {
    machine : true,
    time_period: false,
    check : false,
    aggfunc : false,
    date : false,
    date_2 : false,
    time: false,
    time2: false,
    select_1: 24
  },
      dataDownload: [],
      search: "",
      operatorsData: [],
      menu: false,
      headersData: [],
      pagination: {
        page: null,
        itemsPerPage: null,
        pageStart: null,
        pageStop: null,
        pageCount: null,
        itemsLength: null,
      },
    };
  },

  mounted() {},

  methods: {
    DateSort: function(items, index, isDesc) {
      if (index[0] == "Timestamp") {
              console.log("chekcing index inside if",items);

        items.sort((a, b) => {
          if (!isDesc[0]) {
            return new Date(b[index]) - new Date(a[index]);
          } else {
            return new Date(a[index]) - new Date(b[index]);
          }
        });
      } else if (
        index[0] != "Timestamp" 
      ) {
                      console.log("chekcing index inside elif",items);

        items.sort((a, b) => {
          if (!isDesc[0]) {
            if (typeof a[index] == "number" ) {
                return b[index] - a[index];
            }
            else
            {
            console.log("checking incase a isDesc");

            }
          } else {
             if (typeof a[index] == "number" ) {
                return a[index] - b[index];
            }
            else{
            console.log("checking incase else", a[index], b[index]);

            }
          }
        });
      }

      return items;
    },

    selected(crumb) {
      if (crumb === "Home") {
        router.push(`/${sessionStorage.getItem("route_first_option")}`);
      }

      console.log(crumb);
    },
    createPDF() {
      let content = this.$refs["theDataTable"];
      console.log("pagination", this.pagination);
      let doc = new jsPDF("latitude");
      doc.text(14, 7.5, "Machine Production Report");
       doc.addImage(
        this.getImgUrl1(this.$config.image_inside_pdf),
        "png",
        this.$config.first_dimension_separate_again,
        this.$config.second_dimension_separate,
        this.$config.third_dimension_separate,
        this.$config.fourth_dimension_separate_again
      );
      let columnHeaders = [
        "Timestamp",
        "Machine",
        "Availability",
        "Performance",
        "Quality",
        "OEE",
        "Production Quantity",
        // "Hourly Records",
        "Runtime(Mins)",
        "Wastage",
        "Total Production"
        
        
      ];
      let rows = [];
      content.items.forEach((data, index) => {
        if (
          index >= this.pagination.pageStart &&
          index < this.pagination.pageStop
        ) {
          let tempRow = [    
            data.Timestamp || "",
            data.Machine || "",
            data.Availability || 0,
            data.Performance || 0,
            data.Quality || 0,
            data.OEE || 0,
            data.Production_Quantity || 0,
            // data.Hourly_Records || "",
            data.Runtime || 0,
                        data.Wastage || 0,
            data.Total_Production || 0,
            
          ];
          rows.push(tempRow);
        }
      });
      console.log("checkign temp row=>", rows);
      doc.setFontSize(9);
      doc.autoTable(columnHeaders, rows, { startY: 11.5 });
      let d = new Date();
      doc.save(
        `Machine_Production_Report ${d.toISOString().slice(0, 10) +
          " " +
          d
            .toTimeString()
            .split("(")[0]
            .slice(0, -1)}.pdf`
      );
    },
    intervalFetchData: function(
      machine_id,
      startDate,
      endDate,
      show,
      grp_show,
      check
    ) {
      this.machine_id_Selected = machine_id;
      this.start_date = startDate;
      this.end_date = endDate;
      console.log("machine id", machine_id);
      console.log(
        "selected start date",
        startDate,
        "selected end date",
        startDate
      );

      this.searchNew(
        this.machine_id_Selected,
        startDate,
        endDate,
        show,
        grp_show,
        check
      );
    },
      sortKeys(obj_1,key) {
          let ditItem = {}
            console.log("checking keys and dicts outside",obj_1,key)
              for (let i in key )
              {
ditItem[key[i]] = obj_1[key[i]];

              }
console.log("Checking ditItem",ditItem);
            return ditItem;
        },
    searchNew: function(machine_id, startDate, endDate, show, grp_show, check) {
      this.start_date = startDate;
      this.end_date = endDate;
      this.machine_id_Selected = machine_id;
      console.log(
        "machine select",
        this.machine_id_Selected,
        "Done to say",
        machine_id,
        check
      );
      let params = "";
      if (this.start_date == "") {
        params = `?machine_id=${machine_id}`;
      } else {
        params = `?machine_id=${machine_id}&startdate=${this.start_date}&enddate=${this.end_date}&agg_function=${show}&timeframe=${grp_show}`;
      }
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getMachineProductionReportData${params}`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.setGridData(config);
    },
    setGridData: function(config) {
      this.headersData = [
                {
          text: "Timestamp",
          value: "Timestamp",
          sortable: true,
        },
        {
          text: "Machine",
          value: "Machine",
          sortable: true,
        },

        {
          text: "Availability",
          value: "Availability",
          sortable: true,
        },

        {
          text: "Performance",
          value: "Performance",
          sortable: true,
        },
        {
          text: "Quality",
          value: "Quality",
          sortable: true,
        },
  {
          text: "OEE",
          value: "OEE",
          sortable: true,
        },
        {
          text: "Production Qty",
          value: "Production_Quantity",
          sortable: true,
        },
        //     {
        //   text: "Hourly Records",
        //   value: "Hourly_Records",
        //   sortable: true,
        // },
        {
          text: "Runtime (Mins)",
          value: "Runtime",
          sortable: true,
        },
        
        // {
        //   text: "Expected Qty.",
        //   value: "Expected_Production",
        //   sortable: true,
        // },
            {
          text: "Wastage",
          value: "Wastage",
          sortable: true,
        },
        
            {
          text: "Total Production",
          value: "Total_Production",
          sortable: true,
        },

      ];

      this.showLoader = true;
      this.showWarning = false;
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          let _data = response.data.data.data;
          console.log("checking report");
          console.log("checkign resp", response.data.data.data);
          console.log("checkign resp keys",response.data.data.keys);
          let keys = response.data.data.keys || [];
          this.operatorsData = response.data.data.data;
          console.log("thisisdata", this.operatorsData);
          let result = [];
          for (let i in this.operatorsData) 
          {
            
            console.log("checking keys before sending",keys,this.operatorsData[i]);
           let val = this.sortKeys(this.operatorsData[i],keys);
            console.log("checking val at also",val);
          result.push( val);

          }
          this.dataDownload = result;
          console.log("checking csv data",result,this.dataDownload);
          this.item = _data;
          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            this.showWarning = true;
            this.item = [];
            console.log("axios error", error.message);
          }
        });
    },
  },
};
</script>
<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>